export { Caption2, caption2ClassNames } from './components/presets/Caption2/index';
